import React from 'react';
import { Flow } from 'flow-react';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import Modal from 'components/UI/Modal/Modal';
import Profile from 'screens/Profile/Profile';
import { checkAndConvertMetadata } from 'helpers/MetadataHelper';
import { showConfirmMsgDlg } from 'helpers/AppHelper';
import { handleMsg, verifyProfile } from 'helpers/ProfileHelper';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as cTypes from 'config/ConfigTypes';
import Spinner from 'layouts/UIElements/Spinner/Spinner';

import './ProfilePage.scss'

const ProfilePage = observer(
    class ProfilePage extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                modalOpened: false,
                showProfile: false,
                formErrors: {},
                loading: false,
                screenMode: cTypes.PROFILE_USER
            }
        }

        formatMessage = ({ id }) => this.props.intl.formatMessage({ id });

        showMsg = ({ msg, hasError = false }) => {
            let htmlMsg = handleMsg({ msg, formatMessage: this.formatMessage });
            showConfirmMsgDlg({
                htmlMsg, formatMessage: this.formatMessage, cb: () => {
                    this.closeModal();
                    if (hasError) {
                        this.props.updateAuthObjects({ shouldLogOut: true });
                        window.location.reload();
                    }
                }
            });
        }

        closeModal = () => {
            this.setState({ modalOpened: false, screenMode: cTypes.PROFILE_USER });
            this.props.setProfileInitialState({});
        }


        handleBtnClick = ({ screenMode }) => {
            this.setState({ subScreen: screenMode });
        }

        handleAction = ({ action, userInputs }) => {
            switch (action) {
                case cTypes.PROFILE_SAVE:
                    let changed = checkAndConvertMetadata({ userInputs });
                    if (changed) userInputs = userInputs;
                    if (userInputs) {
                        const res = verifyProfile({ userInputs, configObjects: this.props.configObjects });
                        if (res) {
                            if (res.noErrors) {
                                this.props.updateUserProfile(userInputs);
                            } else {
                                this.setState({
                                    formErrors: { [this.state.screenMode]: { ...res } },
                                    [this.state.screenMode]: userInputs
                                });
                            }
                        }
                    }
                    break;
                default:
                    this.closeModal();
                    break;
            }
        }
        handleFormClick = () => { }

        showForm = () => {
            switch (this.state.screenMode) {
                default:
                    return <Profile screenMode={this.state.screenMode} subScreen={this.state.subScreen}
                        errors={this.state.formErrors[this.state.screenMode] || {}} authObjects={this.props.authObjects}
                        formatMessage={this.props.intl.formatMessage} onBtnClick={this.handleBtnClick} msg={this.props.msg}
                        onActionClick={this.handleAction} configObjects={this.props.configObjects} loading={this.props.loading}
                        profileObjects={this.props.profileObjects} updateProfileObjects={this.props.updateProfileObjects}
                    />
            }
        }

        componentDidUpdate(prev) {
            const { showProfile, status } = this.props.profileObjects;
            if (!prev.profileObjects.showProfile && showProfile) {
                this.setState({ showProfile: true, modalOpened: true });
            }

            if (prev.profileObjects.status !== status) {
                if (status && status.msg) this.showMsg({ msg: status.msg, hasError: status.error });
            }
        }

        componentDidMount() {
            const { screenMode } = this.props.profileObjects;
            this.setState({ screenMode: screenMode });
        }

        render() {
            return (
                <div className="ProfilePage">
                    <Modal className="profilepage-modal" open={this.state.modalOpened}
                        onClose={() => this.setState({ modalOpened: false })}>
                        <div className="profilepage-close" onClick={this.closeModal}>
                            <FontAwesomeIcon icon={faPlus} />
                        </div>
                        {this.state.showProfile && this.showForm()}
                    </Modal>
                    {this.state.loading && (
                        <div className="profilepage-overlay">
                            <Spinner />
                        </div>)}
                </div>)
        }
    }
)

const mapStateToProps = (state) => ({
    authObjects: state.auth.authObjects,
    profileObjects: state.profile.profileObjects,
    configObjects: state.config.configObjects,
    loading: state.profile.profileObjects.loading,
    msg: state.profile.profileObjects.msg
});

const mapDispatchToProps = (dispatch) => ({
    updateProfileObjects: (obj) => dispatch(actions.updateProfileObjects(obj)),
    setProfileInitialState: () => dispatch(actions.setProfileInitialState()),
    updateUserProfile: (userInputs) => dispatch(actions.updateUserProfile(userInputs)),
    updateAuthObjects: (obj) => dispatch(actions.updateAuthObjects(obj)),
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(ProfilePage))));


